import { CheckboxesOptionModel, RadioButtonsOptionModel } from '@libs/shared/models';
import { CheckboxesInputModel } from '../checkboxes';
import { RadioButtonsInputModel } from '../radio-buttons';

// A selection list renders both option based inputs: `checkboxes` selects any number of options,
// `radioButtons` selects a single one. Both keep the value shape they had as separate inputs.
export type SelectionListInputModel = CheckboxesInputModel | RadioButtonsInputModel;

// `checkboxes` holds a flag per option name, `radioButtons` holds the value of the selected option.
export type SelectionListValue = Record<string, boolean> | string | null;

export type SelectionListOptionModel = CheckboxesOptionModel | RadioButtonsOptionModel;

export const isMultiSelectionList = (data: SelectionListInputModel): data is CheckboxesInputModel => {
  return data.type === 'checkboxes';
};

// The two option models identify an option by a different property, so reads go through this bridge.
export const getSelectionListOptionKey = (option: SelectionListOptionModel): string => {
  return 'name' in option ? option.name : option.value;
};
